export enum TradeType {
  Long = "Long",
  Short = "Short",
  Swap = "Swap",
}
